import { useCallback, useEffect, useRef, useState } from "react";

import { REGISTRATION_READY_AUTO_WAIT_TIMEOUT_MS } from "../firstAccessCrud";

export const REGISTRATION_WAIT_MESSAGE_INTERVAL_MS = 8_000;

export const REGISTRATION_WAIT_MESSAGES = [
  "Criando sua conta na Jusfy...",
  "Preparando seu acesso...",
  "Quase lá, só mais um instante...",
  "Seguimos processando, não feche esta página...",
  "Finalizando os últimos detalhes...",
  "Só mais um momento...",
] as const;

export const REGISTRATION_COMPLETE_MESSAGE = "Cadastro confirmado!";
export const REGISTRATION_SENDING_CODE_MESSAGE =
  "Enviando código para seu e-mail...";

const COMPLETE_ANIMATION_MS = 520;

export function useRegistrationWaitProgress(isActive: boolean) {
  const [progress, setProgress] = useState(0);
  const [messageIndex, setMessageIndex] = useState(0);
  const [smoothComplete, setSmoothComplete] = useState(false);
  const smoothCompleteRef = useRef(false);

  useEffect(() => {
    if (!isActive) {
      setProgress(0);
      setMessageIndex(0);
      setSmoothComplete(false);
      smoothCompleteRef.current = false;
      return;
    }

    const startedAt = Date.now();

    const intervalId = window.setInterval(() => {
      if (smoothCompleteRef.current) {
        return;
      }

      const elapsed = Date.now() - startedAt;
      const nextProgress = Math.min(
        (elapsed / REGISTRATION_READY_AUTO_WAIT_TIMEOUT_MS) * 100,
        100
      );

      setProgress(nextProgress);
      setMessageIndex(
        Math.floor(elapsed / REGISTRATION_WAIT_MESSAGE_INTERVAL_MS) %
          REGISTRATION_WAIT_MESSAGES.length
      );
    }, 100);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [isActive]);

  const animateToComplete = useCallback(async () => {
    smoothCompleteRef.current = true;
    setSmoothComplete(true);
    setProgress(100);

    await new Promise<void>(resolve => {
      window.setTimeout(resolve, COMPLETE_ANIMATION_MS);
    });
  }, []);

  const reset = useCallback(() => {
    setProgress(0);
    setMessageIndex(0);
    setSmoothComplete(false);
    smoothCompleteRef.current = false;
  }, []);

  const message = REGISTRATION_WAIT_MESSAGES[messageIndex];

  return {
    progress,
    message,
    smoothComplete,
    animateToComplete,
    reset,
  };
}
